import { SETTINGS_ROUTE } from '../../config/constant/routePathConstant';
import { MATTRESS_BUILDER_BASE_TYPE, SETTINGS_TAB, TEXTURE_BASE_TYPE, THREE_3D_MODAL_BASE_TYPE } from '../../constants/constants';
import { CURRENT_USER, SELECTED_PLAN } from '../../constants/projectConstants';
import { ADMIN_SETTINGS, MY_PLANS_ROUTE, PRICING_ROUTE } from '../../constants/routePathConstants';
import { getLocalStorage, openFormInCaseOfNewOrgAndFreemiumUser, windowOpen } from '../../helpers/jsHelper';
import { dispatcher, navigate } from '../../helpers/projectHelper';
import { history } from '../../history';
import { selectCurrentLoggedInInfo } from '../../redux/slicers/activitySlicer';
import {
  selectIsCreatorPlan,
  selectIsUserHaveNotAnyPlan,
  selectPlanList,
  selectUserActiveSubscriptionSelfServePlan,
  selectUserPlanList,
  subscriptionActions,
} from '../../redux/slicers/subscriptionSlicer';
import { getAppState } from '../../redux/store';

export const ADD_ONS_PRODUCT_BASE_NAME = {
  '3D_Viewer': '360 Viewer + AR',
  AIVideo: 'AI Video',
  Configurator: 'Configurator',
  Video: 'Video',
  Texture: 'Texture',
  Editor: 'Editor',
  Model3DUploadLimit: '3D Models Upload Limit',
  AIImages: 'AI Images',
  '3D Viewer': '3D Viewer',
  ImagineCredits: 'Imagine Credits'
};

export const OFFER_PRICE_DATA = {
  '3D_Viewer': {
    id: 1,
    product_id: 71,
    product_name: '3D Viewer + AR',
    baseModelType: ADD_ONS_PRODUCT_BASE_NAME['3D_Viewer'],
  },
  AIVideo: {
    id: 2,
    product_id: 91,
    product_name: 'AI Video',
    baseModelType: ADD_ONS_PRODUCT_BASE_NAME.AIVideo,
  },
  Configurator: {
    id: 3,
    product_id: 73,
    product_name: 'Configurator',
    baseModelType: ADD_ONS_PRODUCT_BASE_NAME.Configurator,
  },
  Video: {
    id: 4,
    product_id: 76,
    product_name: 'Video',
    baseModelType: ADD_ONS_PRODUCT_BASE_NAME.Video,
  },
  PanningVideo: {
    id: 5,
    product_id: 91,
    product_name: 'Panning Video',
  },
  '3D_Model_Variation': {
    id: 6,
    product_id: 72,
    product_name: '3D Model Variation',
  },
  '3D Viewer': {
    id: 7,
    product_id: 1048,
    product_name: '3D Viewer',
    baseModelType: ADD_ONS_PRODUCT_BASE_NAME['3D Viewer'],
  },
};

export const VIDEO_STATUS = {
  DONE: 1,
  PROCESSING: 2,
};

export const LINKED_PRODUCT_DATA = {
  THREED_VIEWER: 'Product3DViewer',
  AI_VIDEO: 'AIVideo',
  PRODUCT_VIEWER: 'ProductViewer',
  CONFIGURATOR: 'Configurator',
  VIDEO: 'Video',
  PANNING_VIDEO: 'PanningVideo',
};

export const LINKED_PDP_PRODUCT_DATA = {
  Product3DViewer: 'ar_viewer',
  AIVideo: 'product_video',
  ProductViewer: 'ar_viewer',
  Configurator: 'configurator',
  Video: 'product_video',
  PanningVideo: 'product_video',
};

export const PAYMENT_METHOD_TYPE = {
  CARD: 'card',
  US_BANK_ACCOUNT: 'us_bank_account',
};

export const RECURRING_INTERVAL = {
  MONTH: 1,
  YEAR: 2,
  QUARTER: 3,
  SEMI_ANNUALLY: 4,
};

export const RECURRING_INTERVAL_INFO = {
  1: { interval: 1, count: 1 },
  2: { interval: 2, count: 1 },
  3: { interval: 1, count: 3 },
  4: { interval: 1, count: 6 },
};

const RECURRING_CYCLE = {
  1: 'month',
  2: 'year',
};

export const getBillinCycle = (interval, count) =>
  +Object.keys(RECURRING_INTERVAL_INFO).find(
    (_item) =>
      RECURRING_INTERVAL_INFO[_item]?.interval === +interval &&
      RECURRING_INTERVAL_INFO[_item].count === +count
  );

export const getBillingCycleName = ({ cycle, shortName = false } = {}) => {
  switch (cycle) {
    case RECURRING_INTERVAL.MONTH:
      return shortName ? 'Month' : 'Monthly';
    case RECURRING_INTERVAL.QUARTER:
      return shortName ? 'Quarter' : 'Quarterly';
    case RECURRING_INTERVAL.SEMI_ANNUALLY:
      return shortName ? 'Half Yearly' : 'Semi-Annual';
    case RECURRING_INTERVAL.YEAR:
      return shortName ? 'Year' : 'Yearly';
    default:
      return cycle;
  }
};

export const getPlanRecurringCycle = (cycle, addLY = false) => {
  if (!cycle) return '';
  const _cycle = RECURRING_CYCLE[cycle];
  if (!addLY) {
    return _cycle || '';
  }
  return _cycle + 'ly';
};

export const convertStripeCentsToAmount = (amount, showInDecimal = false) => {
  if (!amount || isNaN(amount)) return 0;
  const convertedAmount = Number(amount) / 100; // stripe takes amount into cents that's why dividing it by 100 to coverting into amount
  return showInDecimal ? convertedAmount.toFixed(2) : convertedAmount;
};

export const navigateToPlans = ({ newTab = false } = {}) => {
  const URL = `${SETTINGS_ROUTE}?activeTab=${SETTINGS_TAB.PLANS}`;
  if (newTab) {
    windowOpen(URL, '_blank');
    return;
  }
  navigate(URL);
};
export const navigateToBilling = ({ newTab = false } = {}) => {
  const URL = `${SETTINGS_ROUTE}?activeTab=${SETTINGS_TAB.BILLING}`;
  if (newTab) {
    windowOpen(URL, '_blank');
    return;
  }
  navigate(URL);
};

export const navigateToUpgradePlan = (props = {}) => {
  const { value = true, browsePlan = false, newTab = false, referrer = false } = props;
  const userHaveNoPlans = selectIsUserHaveNotAnyPlan(getAppState());

  const { isSelfServePlan, isFreemiumUser } = selectCurrentLoggedInInfo(getAppState());
   if (isFreemiumUser) {
     // open enterprise form in case of freemium user whose org is created after 10th Feb 2025
     openFormInCaseOfNewOrgAndFreemiumUser();
     return;
   }

  // const isSelfServePlan = selectUserActiveSubscriptionSelfServePlan(getAppState());
  // if user has no plans i.e., freemium or purchased any new plan i.e., self serve plan then redirect to the pricing page
  if (userHaveNoPlans || isSelfServePlan) {
    if (newTab) {
      // windowOpen(PRICING_ROUTE, '_blank');
      windowOpen(`${ADMIN_SETTINGS}?activeTab=${SETTINGS_TAB.PLANS}`, '_blank'); // MY_PLANS_ROUTE
      return;
    }
    // navigate(PRICING_ROUTE);
    navigate(`${ADMIN_SETTINGS}?activeTab=${SETTINGS_TAB.PLANS}`); // MY_PLANS_ROUTE
    return;
  }

  if (!userHaveNoPlans || value) dispatcher(subscriptionActions.setBrowsePlans(true));
  let params = `?activeTab=${SETTINGS_TAB.PLANS}`;
  if (browsePlan) {
    params += `&browsePlan=${browsePlan}`;
  }
  if (referrer) {
    params += `&referrer=${referrer}`;
  }
  const URL = `${SETTINGS_ROUTE}${params}`;
  if (newTab) {
    windowOpen(URL, '_blank');
    return;
  }
  navigate(URL);
};

export const navigateToAddOns = (props = {}) => {
  const newTab = props?.newTab || false;

  const { isFreemiumOrSelfServeUser, isSelfServePlan } = selectCurrentLoggedInInfo(getAppState());

  let tab = SETTINGS_TAB.ADD_ONS;
  if (isFreemiumOrSelfServeUser) {
    tab = SETTINGS_TAB.PLANS;
    if (isSelfServePlan) { // added this to show addons in case user has purchased a plan
      tab = `${tab}&addons=true`
    }
  }

  const URL = `${SETTINGS_ROUTE}?activeTab=${tab}`;
  if (newTab) {
    windowOpen(URL, '_blank');
    return;
  }
  navigate(URL);
};

export const navigateToSelectedSubscriptionPlans = (plan = null, isSelfServePlan) => {
  const selectedPlan = plan || getLocalStorage(SELECTED_PLAN, true);
  if (selectedPlan?.plan) {
    let params = `${SETTINGS_ROUTE}?activeTab=${SETTINGS_TAB.PLANS}&selectedPlanId=${selectedPlan?.plan}&selectedPlanPriceId=${selectedPlan?.price}&selectedInterval=${selectedPlan?.interval}`;
    if (isSelfServePlan) {
      // params = `${PRICING_ROUTE}?selectedPlanId=${selectedPlan?.plan}&selectedPlanPriceId=${selectedPlan?.price}&selectedInterval=${selectedPlan?.interval}`;
      params = `${MY_PLANS_ROUTE}?selectedPlanId=${selectedPlan?.plan}&selectedPlanPriceId=${selectedPlan?.price}&selectedInterval=${selectedPlan?.interval}`;
    }
    if (
      (selectedPlan?.isTextureType === true || selectedPlan?.isTextureType === 'true') &&
      !isSelfServePlan
    ) {
      params += `&isTextureType=true`;
    }
    if (getLocalStorage(CURRENT_USER)) navigate(params);
  }
};

// converting timestamp to date
export function getDateFromTimestamp(timestamp, dateOnly = false) {
  if (!timestamp) return timestamp;

  const date = new Date(timestamp * 1000);
  const month = date.toLocaleString('default', { month: 'long' });
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const amOrPm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');

  if (dateOnly) {
    return `${month} ${day}, ${year}`;
  }

  return `${month} ${day}, ${year} at ${formattedHours}:${formattedMinutes}:${formattedSeconds} ${amOrPm}`;
}

export const AddOnsTab = {
  RECURRING_ADD_ONS: 1,
  ONE_TIME_ADD_ONS: 2,
};

export const navigateToProductUsageHistory = (value) => {
  dispatcher(subscriptionActions.setShowProductUsageHistory(value));
};

export const PLAN_TYPE_LABEL = {
  TEXTURE: 'TEXTURE',
  BOTH: 'BOTH',
  PRODUCT: 'PRODUCT',
};

export const checkURL = (url) => {
  if (url) {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url; // Append 'https://' by default
    }
  }
  return url;
};

// Function to remove duplicate values
export function removeDuplicateEntriesViaKey(array = [], key = '') {
  if (array.length === 0 || key === '') return [];
  const uniqueValues = [];
  const uniqueObjects = [];

  array.forEach((obj) => {
    const value = obj[key];

    if (!uniqueValues.includes(value)) {
      uniqueValues.push(value);
      uniqueObjects.push(obj);
    }
  });

  return uniqueObjects;
}

export const getCurrentSubscriptionPlanMessage = (user = '') => {
  if (!user) return '';

  let text = '';

  const subscriptionType = user?.organization_detail?.subscription_type?.toLowerCase();
  const subscriptionName = user?.organization_detail?.subscription_name;

  if (subscriptionType === 'freemium') {
    text = 'You are currently on the Free plan.';
  } else if (subscriptionType === 'old_subscription') {
    if (subscriptionName) {
      text = `You are currently on the ${subscriptionName} plan`;
    } else {
      text = 'You are currently on the imagine.io plan.';
    }
  } else if (subscriptionType === 'premium') {
  }

  return text;
};

// 3D Model ID
export const PRODUCT_ID_ONE = 70;

//3D Model Variation ID
export const PRODUCT_ID_TWO = 72;
// Texture Product ID
export const TEXTURE_PRODUCT_ID = 75;
export const TEXTURE_PRODUCT_NAME = 'Texture';
export const THREE_D_MODEL_PRODUCT_NAME = '3D Model';
export const THREE_D_MODEL_VARIATION_PRODUCT_NAME = '3D Model variation';

export const PLAN_TYPE_TAB = {
  CURRENT: 1,
  DOWNGRADED: 2,
  EXPIRED: 3,
};

export const UPLOAD_SUBSCRIPTION_TITLE_BASE_ON_BASE_TYPE = {
  '3d model Upload Limit': 'Models',
  Texture: 'Textures',
  '3D Models Upload Limit': 'Models',
  'Unlimited AI Generation': 'Unlimited AI Generation',
};

export const filterOutMissingFeatureList = (list = []) => {
  const data = [];
  if (list?.length) {
    list.map((item) => {
      if (+item.missing_quantity > 0) {
        data.push(item);
      }
    });
    return data;
  } else {
    return [];
  }
};

/**
 * Generates a list of subscription plans based on the `priceDetails` object that have the 3D Model Limit, Texture Upload Limite & Editors
 * If we don't have an active creator plan, it generates a list of subscription plans based on the `priceDetails` object,
 * excluding plan with price 0
 */
export const getSubscriptionListForCombinePlanPurchase = () => {
  const priceDetails = window.$priceDetails;
  const isCreatorPlan = selectIsCreatorPlan(getAppState());

  const subscriptionList =
    !isCreatorPlan && priceDetails
      ? Object.keys(priceDetails)
          .map((key) => {
            if (priceDetails?.[key]?.unit_amount === '0') return null;

            const isEditor = [ADD_ONS_PRODUCT_BASE_NAME.Editor].includes(key);

            return {
              name: isEditor ? key : priceDetails?.[key]?.nickname || key,
              ...priceDetails[key],
              basemodeltype: key,
              is_subscription_plan: true,
              finalAmount: priceDetails?.[key]?.unit_amount * (priceDetails?.[key]?.qty || 1),
            };
          })
          .filter(Boolean)
      : [];

  return subscriptionList;
};

export const getCurrentCreatorPlanInfo = () => {
  const userPlans = selectUserPlanList(getAppState());
  const activePlan = userPlans?.filter((a) => !a.is_cancelled);

  let _purchasedPlansList = activePlan?.sort((a, b) => a.recurring_interval - b.recurring_interval);
  const haveYearlyEditor = _purchasedPlansList?.some((plan) =>
    plan?.plan_details?.find(
      (plan) =>
        plan.basemodeltype === ADD_ONS_PRODUCT_BASE_NAME.Editor &&
        +plan.recurring_interval_id === RECURRING_INTERVAL.YEAR
    )
  );

  if (_purchasedPlansList?.length > 1 && haveYearlyEditor) {
    _purchasedPlansList = _purchasedPlansList.filter(
      (a) => a.recurring_interval === RECURRING_INTERVAL.YEAR
    );
  }

  return _purchasedPlansList?.[0];
};

export const HIDE_BUY_MORE_FOR_SELF_SERVE_BASE_TYPE_LIST = [
  ADD_ONS_PRODUCT_BASE_NAME.Editor,
  THREE_3D_MODAL_BASE_TYPE,
  TEXTURE_BASE_TYPE,
  MATTRESS_BUILDER_BASE_TYPE,
];

export const HIDE_CANCEL_REQUEST_FOR_ADDONS_BASE_TYPE_LIST = [
  ADD_ONS_PRODUCT_BASE_NAME.Editor,
  THREE_3D_MODAL_BASE_TYPE,
  TEXTURE_BASE_TYPE,
];

export const removeParamsFromUrl = ({ params = [], removeAll = false, skipParams = [] } = {}) => {
  const searchParams = new URLSearchParams(window.location.search);

  if (params?.length > 0) {
    params?.forEach((param) => {
      searchParams.delete(param);
    });
  }

  if (removeAll) {
    searchParams?.forEach((_, key) => {
      if (!skipParams?.includes(key)) {
        searchParams.delete(key);
      }
    });
  }

  history?.replace({
    search: searchParams.toString(),
  });
};


  /**
   * Calculates the plan price based on the provided plan details.
   *
   * @param {object} [plan=null] - The plan object containing the plan details.
   * @param {boolean} [convertStripeAmount=true] - Whether to convert the plan price from Stripe cents to the actual amount.
   * @returns {number} The calculated plan price.
   */
export const calculatePlanPrice = ({ plan = null, convertStripeAmount = true, checkForCancelledPlan = false } = {}) => {
  if (!plan) return 0;

  const plans = selectPlanList(getAppState());

  let amount = 0;

  /**
   * This function filters the `plan_details` array to find the plans with the specified `basemodeltype` values, and then calculates the total price by multiplying the `price_amount` and `product_quantity` for each matching plan.
   *
   * If the total price is 0, the function returns 0 to indicate that the creator plan being canceled.
   *
   * @param {object} plan - The plan object containing the plan details.
   * @returns {number} The total price of the creator's plan that is being canceled, or 0 if there is no plan being canceled.
   */
  if (checkForCancelledPlan) {
    const isCreatorPlanCancel = plan?.plan_details
      ?.filter((a) =>
        [
          ADD_ONS_PRODUCT_BASE_NAME.Editor,
          ADD_ONS_PRODUCT_BASE_NAME.Texture,
          ADD_ONS_PRODUCT_BASE_NAME.Model3DUploadLimit,
        ].includes(a.basemodeltype)
      )
      ?.reduce((acc, cur) => acc + +cur?.price_amount * cur?.product_quantity, 0);

    if (isCreatorPlanCancel === 0) return 0;
  }

  /**
   * This function first filters the plan details to separate the non-downgraded and downgraded plan amounts.
   * It then calculates the total plan price by adding the non-downgraded and downgraded plan amounts.
   * If the `convertStripeAmount` option is set to `true`, the function will convert the plan price from Stripe cents to the actual amount.
   *
   * @returns {number} The calculated plan price.
   */
  const nonDowngradedPlanAmount = plan?.plan_details
    ?.filter((a) => !a?.next_downgrade_price_id)
    ?.reduce((acc, cur) => acc + +cur?.price_amount * cur?.product_quantity, 0);

  const downgradedPlanAmount = plan?.plan_details
    ?.filter((a) => a?.next_downgrade_price_id)
    ?.reduce((acc, curr) => {
      const _downgradePlanInfo = plans?.find((a) => a?.id === +curr?.plan_id);
      const _downgradePriceInfo = _downgradePlanInfo?.pricing_details?.find(
        (a) => a?.stripe_price_id === curr?.next_downgrade_price_id
      );
      const _downgradePriceUnitAmount = _downgradePriceInfo?.unit_amount
        ? Number(_downgradePriceInfo?.unit_amount)
        : 0;

      return (
        acc +
        _downgradePriceUnitAmount * (curr?.product_quantity === 0 ? 0 : curr?.product_quantity || 1)
      );
    }, 0);

  amount = nonDowngradedPlanAmount + downgradedPlanAmount;
  if (convertStripeAmount) {
    amount = convertStripeCentsToAmount(amount);
  }

  return amount;
};

export const CHECKOUT_ADD_PAYMENT_METHOD_POPUP_FORM = 'OPEN_ADD_CARD_FORM';
export const MAKE_CHECKOUT_API_CALL = 'MAKE_CHECKOUT_API_CALL';

export const PLAN_ITEM_NAMES = {
  [THREE_3D_MODAL_BASE_TYPE]:"Model Limit Plan",
  [TEXTURE_BASE_TYPE]:"Textures Limit Plan",
}
export const FABRIC_SEAMLESS_CREATION_BASE_TYPE = 'Fabric Seamless Creation';
export const FABRIC_SEAMLESS_PRODUCTION_CREATION_BASE_TYPE = 'Texture Seamless Creation';

export const BASE_TYPE_TO_SHOW_ADD_ONS = [
  THREE_D_MODEL_VARIATION_PRODUCT_NAME,
  THREE_D_MODEL_PRODUCT_NAME,
  FABRIC_SEAMLESS_CREATION_BASE_TYPE,
  FABRIC_SEAMLESS_PRODUCTION_CREATION_BASE_TYPE,
];
